import React from 'react';
import { HeadlineCarouselState } from './HeadlineCarousel.state';
import { TabItem, TabsWrapper } from 'src/domains/layouts/shared/tabs/Tabs.style';

interface PropsTypes {
    headlineCarouselsState: HeadlineCarouselState;
}

export const HeadlineCarouselNav = ({ headlineCarouselsState }: PropsTypes): JSX.Element => {
    return (
        <TabsWrapper>
            <TabItem
                isActive={headlineCarouselsState.collection === 'casino'}
                onClick={(): void => headlineCarouselsState.onChangeCollection('casino')}
            >
                Casino
            </TabItem>
            <TabItem
                isActive={headlineCarouselsState.collection === 'live-casino'}
                onClick={(): void => headlineCarouselsState.onChangeCollection('live-casino')}
            >
                Live Casino
            </TabItem>
            <TabItem
                isActive={headlineCarouselsState.collection === 'virtuals'}
                onClick={(): void => headlineCarouselsState.onChangeCollection('virtuals')}
            >
                Virtuals
            </TabItem>
        </TabsWrapper>
    );
};
